export default __webpack_public_path__ + "cdda20962d137e8a3ea1ca8c49564a6f.png";